var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-create" },
    [
      _vm.isLoadingFirmData
        ? _c("b-alert", { attrs: { show: true, variant: "info" } }, [
            _vm._v("\n        Lade Firmendaten ...\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowForm
        ? _c(
            "b-form",
            {
              staticClass: "record-create",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "record-creation-wrapper" }, [
                _c(
                  "div",
                  { attrs: { role: "tablist" } },
                  [
                    _c(
                      "csp-foldable",
                      {
                        attrs: {
                          "collapse-id": "intro",
                          "link-to-section": "base",
                          "route-name": "record-create",
                          title: "Allgemeine Informationen",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "collapse-body p-5" },
                          [
                            _c("h2", [
                              _vm._v(
                                "\n                            Willkommen bei "
                              ),
                              _c("span", { staticClass: "text-tertiary" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.selectedFirmNameWithPlace
                                        ? _vm.selectedFirmNameWithPlace
                                        : " Ihrem Autohaus"
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.shouldShowPersonalGreeting
                              ? [
                                  _c("p", [
                                    _vm._v("Liebe Kundin, lieber Kunde,"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                wir freuen uns sehr über das uns entgegengebrachte Vertrauen im Zusammenhang mit\n                                der Bearbeitung Ihres Unfallschadens.\n                                Bitte geben Sie nun alle Ihnen bekannten Daten ein.\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                Sollten Sie Fragen zur Aufnahme der Daten haben, stehen wir Ihnen telefonisch gern\n                                " +
                                        _vm._s(
                                          _vm.selectedFirmPhone
                                            ? " unter " + _vm.selectedFirmPhone
                                            : ""
                                        ) +
                                        " zur Verfügung.\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                Freundliche Grüße"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "Ihr\n                                " +
                                        _vm._s(
                                          _vm.selectedFirmNameWithPlace
                                            ? _vm.selectedFirmNameWithPlace
                                            : " Autohaus"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                ]
                              : _vm.isFleetOrMajorCustomer
                              ? [
                                  _c("p", [
                                    _vm._v(
                                      "\n                                Liebe Fahrzeugnutzerin, Lieber Fahrzeugnutzer,\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                wir bedauern sehr, dass es zu einem Unfall mit Ihrem Fahrzeug gekommen ist.\n                                In Kürze wird sich eine unserer Mitarbeiterinnen / einer unserer Mitarbeiter um den\n                                Vorgang kümmern. Um die nun erforderlichen Aktivitäten schnellstmöglich beginnen\n                                zu können, bitten wir Sie, uns bei der Datenaufnahme zu unterstützen.\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                Bitte beantworten Sie die folgenden Fragen. Sollten Sie etwas nicht wissen,\n                                lassen Sie das Feld gern frei.\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                Herzlichen Dank für Ihre Hilfe und los geht ́s...\n                            "
                                    ),
                                  ]),
                                ]
                              : [
                                  _c("p", [
                                    _vm._v("Liebe Kundin, lieber Kunde,"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "\n                                in wenigen Minuten wird sich eine unserer Mitarbeiterinnen / einer unserer\n                                Mitarbeiter persönlich um Sie kümmern.\n                                Um Ihnen die Wartezeit zu verkürzen, bitten wir Sie, uns bei der Datenaufnahme zu\n                                unterstützen.\n                                Bitte beantworten Sie die folgenden Fragen.\n                                Sollten Sie etwas nicht wissen, lassen Sie das Feld gerne frei.\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      "Herzlichen Dank für Ihre Hilfe und los geht´s..."
                                    ),
                                  ]),
                                ],
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "csp-foldable",
                      {
                        attrs: {
                          "collapse-id": "base",
                          "link-classes": _vm.stateClasses(
                            "/((claimType|damage)/|firmId)"
                          ),
                          "link-to-section": "customer",
                          "route-name": "record-create",
                          "route-params": {},
                          title: "Schritt 1 - Unfalldaten",
                        },
                      },
                      [
                        _c("csp-record-create-base-by-customer", {
                          attrs: { "record-form": _vm.recordForm },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "csp-foldable",
                      {
                        attrs: {
                          "collapse-id": "customer",
                          "link-classes": _vm.stateClasses("/customer/"),
                          "link-to-section": "vehicle",
                          "route-name": "record-create",
                          "route-params": {},
                          title: "Schritt 2 - Persönliche Daten",
                        },
                      },
                      [
                        _c("csp-record-create-customer", {
                          attrs: {
                            "is-fleet-or-major-customer":
                              _vm.isFleetOrMajorCustomer,
                            "record-form": _vm.recordForm,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "csp-foldable",
                      {
                        attrs: {
                          "collapse-id": "vehicle",
                          "link-classes": _vm.stateClasses("/vehicle/"),
                          "link-to-section": _vm.vehicleSectionLinkTo,
                          "route-name": "record-create",
                          "route-params": {},
                          title: "Schritt 3 - Fahrzeugdaten",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "collapse-body mb-0" },
                          [
                            _c("csp-create-vehicle-form", {
                              attrs: {
                                "is-comprehensive-claim-type-selected":
                                  _vm.isComprehensiveClaimTypeSelected,
                                "upload-session-id": _vm.uploadSessionId,
                                "vehicle-form":
                                  _vm.recordForm.getSubformVehicle(),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isComprehensiveClaimTypeSelected
                      ? _c(
                          "csp-foldable",
                          {
                            attrs: {
                              "collapse-id": "adversary",
                              "link-classes": _vm.stateClasses("/adversary/"),
                              "link-to-section": "completion",
                              "route-name": "record-create",
                              "route-params": {},
                              title: "Schritt 4 - Daten Unfallgegner",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "collapse-body pb-0" },
                              [
                                _c("csp-create-adversary-form", {
                                  attrs: { "record-form": _vm.recordForm },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isComprehensiveClaimTypeSelected
                      ? _c(
                          "csp-foldable",
                          {
                            attrs: {
                              "collapse-id": "comprehensive-insurance",
                              "link-classes": _vm.stateClasses(
                                "/comprehensiveInsurancePolicy/"
                              ),
                              "link-to-section": "completion",
                              "route-name": "record-create",
                              "route-params": {},
                              title: "Schritt 4 - Daten Versicherung",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "collapse-body pb-0" },
                              [
                                _c("csp-create-insurance-policy-form", {
                                  attrs: {
                                    "insurance-policy-form":
                                      _vm.recordForm.getSubform(
                                        "comprehensiveInsurancePolicy"
                                      ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "csp-foldable",
                      {
                        attrs: {
                          "collapse-id": "completion",
                          "route-name": "record-create",
                          title: "Abschluss",
                        },
                      },
                      [
                        _c("div", { staticClass: "collapse-body p-5" }, [
                          _c("h2", [
                            _vm._v(
                              "Ganz herzlichen Dank für Ihre Unterstützung."
                            ),
                          ]),
                          _vm._v(" "),
                          !_vm.isFleetOrMajorCustomer
                            ? _c("p", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.customerLabel) +
                                    ",\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                            Hinterlassen Sie uns gerne weitere Informationen im nachfolgenden Feld oder rechts\n                            per Foto-Upload.\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-9" },
                              [
                                _c("csp-form-group-textarea", {
                                  attrs: {
                                    form: _vm.recordForm,
                                    "label-property": "furtherRemarks",
                                    property: "note",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-3 align-self-center" },
                              [
                                _c("csp-record-create-image-file-upload", {
                                  attrs: {
                                    "accepted-mime-types":
                                      "image/jpeg, image/png, application/pdf",
                                    "transform-mime-types":
                                      "image/jpeg, image/png",
                                    "upload-file-category-id":
                                      _vm.miscUploadFileCategory,
                                    "upload-session-id": _vm.uploadSessionId,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                            Bitte klicken Sie nun unten rechts auf\n                            "
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-primary text-uppercase font-weight-bold",
                              },
                              [_vm._v("SPEICHERN")]
                            ),
                            _vm._v(
                              ".\n                            Sollte es noch Rückfragen geben, wird sich eine Mitarbeiterin / ein Mitarbeiter\n                            von uns mit Ihnen in Verbindung setzen. Falls bereits ein Vor-Ort Termin in der\n                            Werkstatt vereinbart wurde, werden alle weiteren Daten dann direkt bei uns ergänzt.\n                        "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "record-creation-footer footer text-center" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "text-right" },
                          [
                            _c("csp-form-group-checkbox", {
                              attrs: {
                                form: _vm.recordForm,
                                "hide-label": true,
                                property: "isPrivacyPolicyAcknowledged",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n                                    Ich habe die\n                                    "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "https://autoclaim.de/datenschutz/",
                                              rel: "noopener noreferrer",
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("Datenschutzerklärung")]
                                        ),
                                        _vm._v(
                                          "\n                                    zur Kenntnis genommen\n                                "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3340301401
                              ),
                            }),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "btn-action",
                                attrs: {
                                  disabled: _vm.isCreating,
                                  type: "submit",
                                  variant: "primary",
                                },
                              },
                              [
                                _vm.isCreating
                                  ? _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm",
                                      attrs: {
                                        "aria-hidden": "true",
                                        role: "status",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                                Speichern\n                            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowMissingFirmsWarning
        ? _c("b-alert", { attrs: { show: true, variant: "warning" } }, [
            _vm._v(
              "\n        Es stehen keine Firmen zur Verfügung, für die Akten angelegt werden können!\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoadingFirms
        ? _c("b-alert", { attrs: { show: true, variant: "info" } }, [
            _vm._v("\n        Lade Filialdaten ...\n    "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }